import React from 'react';

import { Filter } from '@gogame/filters';

import {
  FILTER_TYPES,
  FILTER_BUSINESS_PARTNERS,
  FILTER_AFFILIATES,
  FILTER_EVENTS,
  FILTER_PARTNERS,
  FILTER_APPLICATIONS,
  FILTER_ACTIVITY_TYPES,
} from 'scenes/Integrations/constants';
import * as filtersSource from 'scenes/Integrations/sources/filters';

export const Types = (props) => {
  return (
    <Filter.MultiSelect
      title={'Types'}
      name={FILTER_TYPES}
      source={filtersSource.loadTypes}
      placeholder={'All'}
      {...props}
    />
  );
};

export const BusinessPartners = (props) => {
  return (
    <Filter.MultiSelect
      title={'Business partners'}
      name={FILTER_BUSINESS_PARTNERS}
      source={filtersSource.loadBusinessPartners}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Affiliates = (props) => {
  return (
    <Filter.MultiSelect
      title={'Affiliates'}
      name={FILTER_AFFILIATES}
      source={filtersSource.loadAffiliates}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Events = (props) => {
  return (
    <Filter.MultiSelect
      title={'Events'}
      name={FILTER_EVENTS}
      source={filtersSource.loadEvents}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Partners = (props) => {
  return (
    <Filter.MultiSelect
      title={'Partners (for Conversions)'}
      name={FILTER_PARTNERS}
      source={filtersSource.loadPartners}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Applications = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={filtersSource.loadApplications}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ActivityType = (props) => {
  return (
    <Filter.MultiSelect
      title={'Activity Types'}
      name={FILTER_ACTIVITY_TYPES}
      source={filtersSource.loadActivityTypes}
      placeholder={'All'}
      {...props}
    />
  );
};
